import { getJwtTokenObject } from "../utils/jwt";
import ajax from "./ajax";

export const getAccessTokenApi = () => {
  return ajax({
    method: "post",
    url: "/oauth/token",
    data: {
      'grant_type': 'password',
      'password': 'api',
      'username': 'api',
      'client_id': 'ttMZ2nDcE5kSBBDnUJmdktU5qE85VxireiW2NB4Hunk',
      'client_secret': 'Werder125zx',
      'scope': 'naut_api_dev'
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getRefreshTokenApi = () => {
  return ajax({
    method: "post",
    url: "/oauth/token",
    data: {
      'grant_type': 'refresh_token',
      'client_id': 'ttMZ2nDcE5kSBBDnUJmdktU5qE85VxireiW2NB4Hunk',
      'client_secret': 'Werder125zx',
      'refresh_token': getJwtTokenObject()?.refresh_token || "",
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getCsrfTokenApi = () => {
  return ajax({
    method: "get",
    url: "/session/token",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
